$(document).ready(function () {
  var currentStep = 0;
  var steps = $(".form__step");

  function showStep(step) {
    steps.removeClass("show").addClass("hide");
    steps.eq(step).removeClass("hide").addClass("show");
    $("#prevBtn").prop("disabled", step === 0);
    $("#nextBtn").text(step === steps.length - 1 ? "Submit" : "Next");
    currentStep = step;
  }

  $("#nextBtn").on("click", function () {
    if (currentStep < steps.length - 1) {
      console.log(currentStep);
      if (currentStep + 1 === 1) {
        $("#username_display").text($("#about_you_input").val());
      }
      showStep(currentStep + 1);
    } else {
      alert("Form submitted!");
    }
  });

  $("#prevBtn").on("click", function () {
    if (currentStep > 0) {
      showStep(currentStep - 1);
    }
  });

  showStep(currentStep);
});
